import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 gap-x-4 mt-6" }
const _hoisted_2 = { class: "flex flex-col gap-y-4" }
const _hoisted_3 = { class: "w-full mt-2" }
const _hoisted_4 = { class: "grid grid-cols-3 gap-x-2 mt-2" }
const _hoisted_5 = { class: "text-left font-semibold" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Foto sebelum & sesudah paket packing ")
const _hoisted_7 = {
  key: 0,
  class: "text-gray-lp-500 font-normal"
}
const _hoisted_8 = { class: "flex flex-row items-center" }
const _hoisted_9 = { class: "flex flex-row items-center gap-x-4 pb-2" }
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_UploadImageTiny = _resolveComponent("UploadImageTiny")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Title, {
      fontSize: "20",
      label: _ctx.$t('bookingShipment.column.additionalInformation'),
      fontColor: "text-gray-lp-300",
      hint: "(Khusus INTERPACK)"
    }, null, 8, ["label"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_DataWrapper, {
        label: "Detail Komoditas",
        tooltipTitle: _ctx.$t('bookingShipment.tooltip.detailCommodity'),
        tooltipDescription: _ctx.$t('bookingShipment.tooltip.detailCommodityMsg'),
        fontSize: 14,
        optional: !_ctx.internationalDocumentDetail.commodity
      }, {
        default: _withCtx(() => [
          _createVNode(_component_lp_input, {
            id: "text_area_detail_komoditas_interpack_edit_booking",
            type: "textarea",
            modelValue: _ctx.modelValue.sttCommodityDetail,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue.sttCommodityDetail = $event)),
            placeholder: _ctx.$t('bookingShipment.placeholder.commodityDetails'),
            format: _ctx.replaceNewLine,
            maxLength: 1000,
            showMaxLength: true,
            textAreaRows: "8",
            onChange: _ctx.validateCommodity,
            error: _ctx.internationalDocumentDetail.commodity && _ctx.error.commodity,
            errorCaption: _ctx.$t('bookingShipment.error.detailCommodity'),
            onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setFieldIndex(_ctx.indexErrorCommodity))),
            disabled: _ctx.disabledFields[0],
            disableBackground: _ctx.disabledFields[0]
          }, null, 8, ["modelValue", "placeholder", "format", "onChange", "error", "errorCaption", "disabled", "disableBackground"])
        ]),
        _: 1
      }, 8, ["tooltipTitle", "tooltipDescription", "optional"]),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_DataWrapper, {
          label: "Email",
          fontSize: 14,
          tooltipTitle: " ",
          tooltipDescription: " ",
          optional: !_ctx.internationalDocumentDetail.email
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LpInput, {
              id: "input_email_interpack_edit_booking",
              type: "email",
              placeholder: "Contoh: nama@email.com",
              modelValue: _ctx.modelValue.sttRecipientEmail,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.sttRecipientEmail = $event)),
              error: !!_ctx.errorEmail,
              errorCaption: _ctx.errorEmail,
              onChange: _ctx.inputEmail,
              disabled: _ctx.disabledFields[1]
            }, null, 8, ["modelValue", "error", "errorCaption", "onChange", "disabled"])
          ]),
          _: 1
        }, 8, ["optional"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('bookingShipment.column.sttIdentityNumber'),
          fontSize: 14,
          optional: !_ctx.internationalDocumentDetail.idcIsIdentityNumber
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LpInput, {
              id: "input_nomor_id_penerima_interpack_edit_booking",
              placeholder: _ctx.$t('bookingShipment.placeholder.sttIdentityNumber'),
              modelValue: _ctx.modelValue.sttIdentityNumber,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.modelValue.sttIdentityNumber = $event)),
              error: !!_ctx.errorSttIdentityNumber,
              errorCaption: _ctx.errorSttIdentityNumber,
              onChange: _ctx.inputSttIdentityNumber,
              disabled: _ctx.disabledFields[2],
              maxLength: 100,
              alphanumeric: ""
            }, null, 8, ["placeholder", "modelValue", "error", "errorCaption", "onChange", "disabled"])
          ]),
          _: 1
        }, 8, ["label", "optional"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('bookingShipment.column.sttInterTaxNumber'),
          fontSize: 14,
          optional: !_ctx.internationalDocumentDetail.idcIsTaxIdentificationNumber
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LpInput, {
              id: "input_nomor_tax_id_penerima_interpack_edit_booking",
              placeholder: _ctx.$t('bookingShipment.placeholder.sttInterTaxNumber'),
              modelValue: _ctx.modelValue.sttInterTaxNumber,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.modelValue.sttInterTaxNumber = $event)),
              error: !!_ctx.errorSttInterTaxNumber,
              errorCaption: _ctx.errorSttInterTaxNumber,
              onChange: _ctx.inputSttInterTaxNumber,
              disabled: _ctx.disabledFields[3],
              maxLength: 100,
              alphanumeric: ""
            }, null, 8, ["placeholder", "modelValue", "error", "errorCaption", "onChange", "disabled"])
          ]),
          _: 1
        }, 8, ["label", "optional"])
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_DataWrapper, {
        label: "Foto Pendukung",
        fontSize: 14
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_card, { class: "p-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_DataWrapper, {
                  fontSize: 14,
                  optional: !_ctx.internationalDocumentDetail.afterPacking,
                  class: 
                _ctx.disabledFields[4] && _ctx.disabledFields[5]
                  ? 'opacity-50 cursor-not-allowed'
                  : ''
              
                }, {
                  label: _withCtx(() => [
                    _createVNode("div", _hoisted_5, [
                      _hoisted_6,
                      (!_ctx.internationalDocumentDetail.afterPacking)
                        ? (_openBlock(), _createBlock("span", _hoisted_7, " (" + _toDisplayString(_ctx.$t("optional")) + ") ", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_8, [
                      _createVNode("div", _hoisted_9, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.proofPhotos, (photo, index) => {
                          return (_openBlock(), _createBlock("div", { key: index }, [
                            (index < 2)
                              ? (_openBlock(), _createBlock(_component_UploadImageTiny, {
                                  key: 0,
                                  id: 
                        !index
                          ? 'input_file_foto_sebelum_interpack_edit_booking'
                          : 'input_file_foto_sesudah_interpack_edit_booking'
                      ,
                                  widthImage: "w-full",
                                  accept: "image/jpg, image/jpeg",
                                  title: photo,
                                  modelValue: _ctx.attachmentImage[index],
                                  "onUpdate:modelValue": ($event: any) => (_ctx.attachmentImage[index] = $event),
                                  defaultImage: _ctx.storageImages[index],
                                  maxSize: 5,
                                  multipleIndex: index,
                                  disabled: _ctx.disabledFields[!index ? 4 : 5],
                                  onUpload: ($event: any) => (_ctx.upload($event, !index ? 4 : 5)),
                                  onRemove: ($event: any) => (_ctx.remove(!index ? 0 : 1, !index ? 4 : 5)),
                                  class: 
                        _ctx.disabledFields[!index ? 4 : 5]
                          ? 'opacity-50 cursor-not-allowed'
                          : ''
                      
                                }, null, 8, ["id", "title", "modelValue", "onUpdate:modelValue", "defaultImage", "multipleIndex", "disabled", "onUpload", "onRemove", "class"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["optional", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_card, { class: "p-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_DataWrapper, {
                  label: "Foto KTP",
                  fontSize: 14,
                  optional: !_ctx.internationalDocumentDetail.ktp,
                  class: _ctx.disabledFields[6] ? 'opacity-50 cursor-not-allowed' : ''
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_10, [
                      _createVNode(_component_UploadImageTiny, {
                        id: "input_file_foto_id_penerima_interpack_edit_booking",
                        accept: "image/jpg, image/jpeg",
                        title: _ctx.proofPhotos[2],
                        modelValue: _ctx.attachmentImage[2],
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.attachmentImage[2] = $event)),
                        defaultImage: _ctx.storageImages[2],
                        maxSize: 5,
                        multipleIndex: 2,
                        disabled: _ctx.disabledFields[6],
                        onUpload: _cache[7] || (_cache[7] = ($event: any) => (_ctx.upload($event, 6))),
                        onRemove: _cache[8] || (_cache[8] = ($event: any) => (_ctx.remove(2, 6)))
                      }, null, 8, ["title", "modelValue", "defaultImage", "disabled"])
                    ])
                  ]),
                  _: 1
                }, 8, ["optional", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_card, { class: "p-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_DataWrapper, {
                  label: "Foto NPWP",
                  fontSize: 14,
                  optional: !_ctx.internationalDocumentDetail.npwp,
                  class: _ctx.disabledFields[7] ? 'opacity-50 cursor-not-allowed' : ''
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_11, [
                      _createVNode(_component_UploadImageTiny, {
                        id: "input_file_foto_tax_id_penerima_interpack_edit_booking",
                        accept: "image/jpg, image/jpeg",
                        title: _ctx.proofPhotos[3],
                        modelValue: _ctx.attachmentImage[3],
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.attachmentImage[3] = $event)),
                        defaultImage: _ctx.storageImages[3],
                        maxSize: 5,
                        multipleIndex: 3,
                        disabled: _ctx.disabledFields[7],
                        onUpload: _cache[10] || (_cache[10] = ($event: any) => (_ctx.upload($event, 7))),
                        onRemove: _cache[11] || (_cache[11] = ($event: any) => (_ctx.remove(3, 7)))
                      }, null, 8, ["title", "modelValue", "defaultImage", "disabled"])
                    ])
                  ]),
                  _: 1
                }, 8, ["optional", "class"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ])
  ]))
}